<template>
  <v-card>
    <Cabecera 
      :tipoModuloActual="'condiciones'"
      :incrustado="incrustado"
      v-if="!simplificada"
    />
    <StepperPortal v-if="!incrustado  && !simplificada" tipoModuloActual="condiciones" />
    <v-container fluid>
      <o-base-justify-text v-if="incrustado">
        <span v-html="getTexto('condiciones.bienvenida', promocion.codigo)"/>
      </o-base-justify-text>
      <o-big-title v-if="incrustado">{{titulo}}</o-big-title>
      <v-layout mb-2>
        <v-flex xs12>
          <div v-if="!soyAlquiler">
            <o-base-justify-text v-if="inmueble.inmueblesHijos.length > 0">
              {{$t('reservas.condiciones.precioTexto')}}           
            </o-base-justify-text>
            <ul v-if="inmueble.inmueblesHijos.length > 0">
              <li>
                <o-base-justify-text>
                  {{$t('reservas.condiciones.inmuebleConPrecio', {
                    inmueble: inmueble.descripcionLarga,
                    tarifa: $options.filters['currency'](tarifa.importeTotal),
                    pintadoMasIVA: pintadoMasIVA()
                  })}}    
                </o-base-justify-text>
              </li>
            </ul>         
            <ul
              v-for="inmuebleHijo in inmueble.inmueblesHijos"
              :key="'inmueble-'+inmuebleHijo.id"
            >
              <li>
                <o-base-justify-text v-if="importeTotalHijo(inmuebleHijo) != null">
                  {{$t('reservas.condiciones.inmuebleConPrecioHijo', {
                    inmueble: inmuebleHijo.descripcionLarga, 
                    tarifa: $options.filters['currency'](importeTotalHijo(inmuebleHijo)),
                    pintadoMasIVA: pintadoMasIVA()
                  })}} 
                </o-base-justify-text>
                <o-base-justify-text v-else>
                  {{$t('reservas.condiciones.inmuebleHijo', {inmuebleHijo: inmuebleHijo.descripcionLarga})}}
                </o-base-justify-text>
              </li>
            </ul>
            <o-base-justify-text v-if="getTexto('condiciones.explicativoVenta', promocion.codigo)">
              <span v-html="getTexto('condiciones.explicativoVenta', promocion.codigo)"></span>
            </o-base-justify-text>
            <o-base-justify-text>
                {{$t('reservas.condiciones.valorTotal', 
                  {
                    precioTotal: $options.filters['currency'](total),
                    pintadoMasIVA: pintadoMasIVA()
                })}}
              <template v-if="reserva > 0">
                {{$t('reservas.condiciones.pagoInicial', {
                  reserva: $options.filters['currency'](reserva),
                  pintadoMasIVA: pintadoMasIVA()
                })}}
              </template>
                {{
                  $t('reservas.condiciones.seguidamenteTexto', 
                  {
                    seguidamente: reserva > 0 ? $t('reservas.condiciones.seguidamente') : $t('reservas.condiciones.se'),
                    porcentaje: $options.filters['superDecimalInput'](entradaPorcentaje),
                    reserva: reserva > 0 ? $t('reservas.condiciones.descontando') : '',
                    entrada: $options.filters['currency'](entrada - reservaSinIva),
                    pintadoMasIVA: pintadoMasIVA()
                  })
                }}
              <template v-if="cuotas > 0">
                {{$t('reservas.condiciones.siguientePaso', {
                  porcentaje: $options.filters['superDecimalInput'](cuotasPorcentaje),
                  cuotas: $options.filters['currency'](cuotas)
                })}}
              </template>
            </o-base-justify-text>
            <ul v-for="aplazado in aplazados" :key="'aplazado-'+aplazado.id">
              <li>
                <o-base-justify-text>{{textoAplazado(aplazado)}}</o-base-justify-text>
              </li>
            </ul>
            <o-base-justify-text v-if="resto > 0">
              {{$t('reservas.condiciones.porUltimo', {porcentaje: $options.filters['superDecimalInput'](restoPorcentaje), resto: $options.filters['currency'](resto), pintadoMasIVA: pintadoMasIVA()})}}
            </o-base-justify-text>
            <o-base-justify-text v-if="tienePago && reserva > 0">
              {{$t('reservas.condiciones.esteProceso', {reserva: $options.filters['currency'](reserva), pintadoMasIVA: pintadoMasIVA()})}}
            </o-base-justify-text>
          </div>
          <div v-if="soyAlquiler">
            <o-base-justify-text>
              {{$t('reservas.condiciones.precioAlquiler', {promo: promocion.descripcion})}}           
            </o-base-justify-text>       
            <ul>
              <li>
                <o-base-justify-text>
                  {{inmueble.descripcionLarga}}.
                </o-base-justify-text>
              </li>
              <li 
                v-for="inmuebleHijo in inmueble.inmueblesHijos"
                :key="'inmueble-'+inmuebleHijo.id"
              >
                <o-base-justify-text>
                  {{inmuebleHijo.descripcionLarga}}.
                </o-base-justify-text>
              </li>
            </ul>
            <o-base-justify-text v-if="getTexto('condiciones.explicativoAlquiler', promocion.codigo)">
              <span v-html="getTexto('condiciones.explicativoAlquiler', promocion.codigo)"></span>
            </o-base-justify-text>
            <o-base-justify-text v-if="soyAlquiler">
              {{$t('reservas.condiciones.condicionesAlquiler', {promo: promocion.descripcion})}}
            </o-base-justify-text>
          </div>
        </v-flex>
      </v-layout>
      <ResumenGrafico
        v-if="!soyAlquiler"
        :entrada="entrada"
        :tarifa="tarifa"
        :iva="iva"
        :id="id"
        :cuotas="cuotas"
        :resto="resto"
        :entradaPorcentaje="entradaPorcentaje"
        :reserva="reservaSinIva"
        :numeroCuotas="numeroCuotas"
        :cuotasPorcentaje="cuotasPorcentaje"
        :restoPorcentaje="restoPorcentaje"
        :total="total"
      />
      <div v-else>
        <ResumenAlquiler
          :incrustado="incrustado"
        />
        <o-base-justify-text v-if="tienePago && reservaTotalAlquiler > 0">
          {{$t('reservas.condiciones.procesoAlquiler', {reserva: $options.filters['currency'](reservaTotalAlquiler)})}}
        </o-base-justify-text>
      </div>
      <v-card v-if="!incrustado" class="pa-3" style="max-height:400px; overflow: auto;">
        <o-base-justify-text :marginBottom="false">
          {{politicaPrivacidad}}
        </o-base-justify-text>
      </v-card>
      <v-form ref="form" v-model="valid">
        <v-checkbox
          :label="disabled ? $t('reservas.condiciones.aceptoPrivacy') : $t('reservas.condiciones.aceptoCondiciones')"
          v-model="aceptado"
          :disabled="disabled"
          :rules="[rules.checkboxSelected]"
          hide-details
          color="primary"
        />
      </v-form>
      <v-layout align-center>
        <v-flex xs4>
          <v-btn 
            flat
            class="titleColor--text ml-0 pl-0"
            :disabled="waitingForLoad"
            @click="$router.push({name: 'reservas.id', params: {id:id}})"
            v-if="!incrustado && !simplificada"
            :icon="$vuetify.breakpoint.xsOnly"
          >
            <!-- eslint-disable-next-line -->
            <v-icon>{{$vuetify.breakpoint.xsOnly ? 'arrow_back':'chevron_left'}}</v-icon>
            <span class="hidden-xs-only">{{$t('reservas.condiciones.volver')}}</span>
          </v-btn>
        </v-flex>
        <v-flex xs4>
          <v-layout justify-center>
            <v-btn 
              large
              color="primary"
              :disabled="disabled || waitingForLoad || cargandoExterior"
              :loading="waitingForLoad || cargandoExterior"
              @click="aceptar"
              v-if="!simplificada && incrustado"
            >
            {{$t('general.misc.continuar')}}
            </v-btn>
            <v-btn
                    v-else-if="simplificada"
                    color="primary"
                    title="generar pdf"
                    :disabled="!this.simplificada || waitingForLoad || cargandoExterior"
              :loading="waitingForLoad || cargandoExterior"
                  :href="$downloadCondiciones(reservaActual.id, textoTotalCondiciones)"
                      @click.stop
                      target="_blank"
                  ><v-icon style="margin-right:10px">picture_as_pdf</v-icon>{{$t('general.misc.descargar')}}</v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import rules from '@/mixins/rules'
import ResumenGrafico from './ResumenGrafico'
import Cabecera from '@/components/Cabecera'
import ResumenAlquiler from './ResumenAlquiler'
import StepperPortal from '@/components/StepperPortal'

export default {
  mixins: [rules],
  props: {
    incrustado: {
      type: Boolean,
      default: false
    },
    simplificada: {
      type: Boolean,
      default: false
    },
    cargandoExterior: {
      type: Boolean,
      default: false
    },
    soyAlquiler: {
      type: Boolean
    },
    id: [String, Number]
  },
  components: {
    Cabecera,
    ResumenGrafico,
    ResumenAlquiler,
    StepperPortal
  },
  data () {
    return {
      disabled: false,
      aceptado: false,
      waitingForLoad: false,
      valid: false
    }
  },
  created () {
    this.aceptado = !this.incrustado
    this.disabled = this.aceptado
  },
  computed: {
    ...mapGetters({
      inmueble: 'promociones/inmuebles/getActual',
      promocion: 'promociones/getActual',
      tarifa: 'promociones/inmuebles/tarifas/getActual',
      aplazadosStore: 'promociones/inmuebles/tarifas/aplazados/getAll',
      reservaActual: 'reservas/_id/getActual',
      modulos: 'modulosOrdenes/modulos/getAll',
      politicaPrivacidadStore: 'configuracion/politicaPrivacidad/get',
      tarifaReserva: 'reservas/_id/tarifas/getActual',
      tarifaReservaHijas: 'reservas/_id/tarifas/getHijas',
      tarifaHijaByCodigoActivo: 'reservas/_id/tarifas/getByCodigoActivo'
    }),
    textoIva () {
      return this.tarifa.ivaAlquiler == null ? '' : ' (+' + this.$options.filters['decimalInput'](this.tarifa.ivaAlquiler) + '% IVA)'
    },
    textoTotalCondiciones () {
      let inmuebles = []
      let textosTrasListado = []
      let aplazados = []
      let tarifasHijas = this.tarifaReservaHijas
      let retorno = {}
      if (this.soyAlquiler) {
        tarifasHijas = this.tarifaReservaHijas
        let total = 0
        for (let tarifaHija of tarifasHijas) {
          if (tarifaHija != null && tarifaHija.importeGarantia != null) {
            total += Number(tarifaHija.importeGarantia)
          }
        }
        if (this.tarifa.importeGarantia != null) {
          total += Number(this.tarifa.importeGarantia)
        }
        let garantiaTotal = total
        total = 0
        for (let tarifaHija of tarifasHijas) {
          if (tarifaHija != null && tarifaHija.importeProvision != null) {
            total += Number(tarifaHija.importeProvision)
          }
        }
        if (this.tarifa.importeProvision != null) {
          total += Number(this.tarifa.importeProvision)
        }
        let provisionTotal = total
        let tarifasAlquiler = []
        tarifasAlquiler.push(this.inmueble.descripcionLarga+': '+ this.replaceAll(this.$t('reservas.resumenAlquiler.renta', {periodo: this.periodo, tarifa: this.$options.filters['currency'](this.tarifa.importeAlquiler), textoIva}).replace("\u00a0€","<euros>")))
        for (let tarifaHija of tarifasHijas) {
          if (tarifaHija != null) {
            tarifasAlquiler.push(this.inmueble.inmueblesHijos.find(x => x.codigoActivo === tarifaHija.codigoActivo).descripcionLarga + ': '+this.replaceAll(this.$t('reservas.resumenAlquiler.renta', {periodo: this.periodo, tarifa: this.$options.filters['currency'](tarifaHija.importeAlquiler), textoIva}).replace("\u00a0€","<euros>")))
          }
        }
        
        inmuebles.push(this.inmueble.descripcionLarga)
        this.inmueble.inmueblesHijos.forEach(inmuebleHijo => {
          inmuebles.push(inmuebleHijo.descripcionLarga)
        })
        let textoIva = this.textoIva
        textosTrasListado.push(this.$t('reservas.condiciones.condicionesAlquiler', {promo: this.promocion.descripcion}))
        retorno = {
          textoInicial: this.soyAlquiler ? this.$t('reservas.condiciones.precioAlquiler', {promo: this.promocion.descripcion}) : this.inmueble.inmueblesHijos.length >0 ? this.$t('reservas.condiciones.precioTexto') : '',
          inmuebles: inmuebles,
          textosTrasListado: textosTrasListado,
          fianzaGeneral: this.replaceAll(this.$t('reservaSimplificada.fianzaGeneral', {tarifa: this.$options.filters['currency'](this.fianzaTotalAlquiler)})),
          provisionGeneral: this.replaceAll(this.$t('reservaSimplificada.provisionGeneral', {tarifa: this.$options.filters['currency'](provisionTotal)})),
          garantiaGeneral: this.replaceAll(this.$t('reservaSimplificada.garantiaGeneral', {tarifa: this.$options.filters['currency'](garantiaTotal)})),
          reservaGeneral: this.replaceAll(this.$t('reservaSimplificada.reservaGeneral', {tarifa: this.$options.filters['currency'](this.reservaTotalAlquiler)})),
          renta: tarifasAlquiler,
          tituloRenta: this.$t('reservaSimplificada.rentas')

        } 
      } else {
        this.aplazados.forEach(aplazado => {
          aplazados.push(this.replaceAll(this.textoAplazado(aplazado).replace('&nbsp;€', '').replace("\u00a0€","<euros>")))
        }) 
        inmuebles.push(this.$t('reservas.condiciones.inmuebleConPrecio', {
          inmueble: this.inmueble.descripcionLarga,
          tarifa: this.$options.filters['currency'](this.tarifa.importeTotal),
          pintadoMasIVA: this.pintadoMasIVA()
        }))
        this.inmueble.inmueblesHijos.forEach(inmuebleHijo => {
          inmuebles.push(this.$t('reservas.condiciones.inmuebleConPrecioHijo', {
            inmueble: inmuebleHijo.descripcionLarga, 
            tarifa: this.$options.filters['currency'](this.importeTotalHijo(inmuebleHijo)),
            pintadoMasIVA: this.pintadoMasIVA()
          }))
        });
        retorno = {
          textoInicial: this.soyAlquiler ? this.$t('reservas.condiciones.precioAlquiler', {promo: this.promocion.descripcion}) : this.inmueble.inmueblesHijos.length >0 ? this.$t('reservas.condiciones.precioTexto') : '',
          inmuebles: inmuebles,
          precioTotal: this.replaceAll(this.$t('reservas.condiciones.valorTotal', 
          {
            precioTotal: this.$options.filters['currency'](this.total),
            pintadoMasIVA: this.pintadoMasIVA()
          })),
          reserva: this.reserva > 0 ? this.replaceAll(this.$t('reservas.condiciones.pagoInicial', {
              reserva: this.$options.filters['currency'](this.reserva),
              pintadoMasIVA: this.pintadoMasIVA()})) : '',
          seguidamente: this.replaceAll(this.$t('reservas.condiciones.seguidamenteTexto', 
            {
              seguidamente: this.reserva > 0 ?this. $t('reservas.condiciones.seguidamente') : this.$t('reservas.condiciones.se'),
              porcentaje: this.$options.filters['superDecimalInput'](this.entradaPorcentaje),
              reserva: this.reserva > 0 ? this.$t('reservas.condiciones.descontando') : '',
              entrada: this.$options.filters['currency'](this.entrada - this.reservaSinIva),
              pintadoMasIVA: this.pintadoMasIVA()
            })),
          textoCuotas: this.cuotas > 0 ? this.replaceAll(this.$t('reservas.condiciones.siguientePaso', {
              porcentaje: this.$options.filters['superDecimalInput'](this.cuotasPorcentaje),
              cuotas: this.$options.filters['currency'](this.cuotas)
            })) : '',
          aplazados: aplazados,
          resto: this.resto > 0 ? this.replaceAll(this.$t('reservas.condiciones.porUltimo', {porcentaje: this.$options.filters['superDecimalInput'](this.restoPorcentaje), resto: this.$options.filters['currency'](this.resto), pintadoMasIVA: this.pintadoMasIVA()})) : '',
          final: this.tienePago && this.reserva > 0 ? this.replaceAll(this.$t('reservas.condiciones.esteProceso', {reserva: this.$options.filters['currency'](this.reserva), pintadoMasIVA: this.pintadoMasIVA()})) : ''
        }    
      }
      // return retorno
      return JSON.stringify(retorno)     
    },
    politicaPrivacidad () {
      return this.politicaPrivacidadStore
        .replace('#SOCIPROPNOMBRE', this.promocion.sociedadVendedora)
        .replace('#SOCIPROPCIF', this.promocion.sociedadVendedoraCIF)
        .replace('#SOCIPROPDIRECCION', this.promocion.sociedadVendedoraDireccion)
        .replace('#SOCIGESTNOMBRE', this.promocion.sociedadGestora)
        .replace('#SOCIGESTCIF', this.promocion.sociedadGestoraCIF)
        .replace('#SOCIGESTDIRECCION', this.promocion.sociedadGestoraDireccion)
    },
    tienePago () {
      return this.modulos.some(x => x.tipo === 'pago')
    },
    titulo () {
      return this.getTexto('modulos.condiciones' + (this.soyAlquiler ? 'Alquiler' : ''))
    },
    // miramos si el iva es null
    iva () {
      if (this.incrustado) {
        return this.tarifa.iva == null ? 0 : this.tarifa.iva
      } else {
        return this.tarifaReserva.iva == null ? 0 : this.tarifaReserva.iva
      }
    },
    // importe total del inmueble
    total () {
      if (this.incrustado) {
        let total = 0
        for (let hijo of this.inmueble.inmueblesHijos) {
          if (hijo.tarifa != null) {
            total += Number(hijo.tarifa.importeTotal)
          }
        }
        total += Number(this.tarifa.importeTotal)
        return total
      } else {
        return this.tarifaReserva.importeTotalConHijos
      }
    },
    reservaTotalAlquiler () {
      if (this.incrustado) {
        let total = 0
        for (let hijo of this.inmueble.inmueblesHijos) {
          if (hijo.tarifaAlquiler != null) {
            total += Number(hijo.tarifaAlquiler.importeReserva)
          }
        }
        total += Number(this.tarifa.importeReserva)
        return total
      } else {
        return this.reservaActual.importeReserva
      }
    },
    fianzaTotalAlquiler () {
      let tarifa = null
      let total = 0
      let tarifasHijas = null
      if (this.incrustado) {
        tarifa = this.tarifa
        tarifasHijas = this.inmueble.inmueblesHijos.map(x => x.tarifaAlquiler)
      } else {
        tarifa = this.tarifaReserva
        tarifasHijas = this.tarifaReservaHijas
      }
      for (let hijo of tarifasHijas) {
        if (hijo.tarifa != null) {
          total += Number(hijo.tarifa.importeFianza)
        }
      }
      total += Number(tarifa.importeFianza)
      return total
    },
    // Calculamos el importe o porcentaje de la reserva en base al que tengamos
    reserva () {
      if (this.incrustado) {
        let total = 0
        for (let hijo of this.inmueble.inmueblesHijos) {
          if (hijo.tarifa != null) {
            total += Number(hijo.tarifa.importeReserva)
          }
        }
        total += Number(this.tarifa.importeReserva)
        if (total > this.entrada) {
          total = this.entrada
        }
        return total
      } else {
        return this.reservaActual.importeReserva
      }
    },
    reservaSinIva () {
      return this.reserva * 100 / (100 + Number(this.iva))
    },
    // calculamos el importe o porcentaje de entrada en base al que tengamos
    entrada () {
      if (this.incrustado) {
        let total = 0
        for (let hijo of this.inmueble.inmueblesHijos) {
          if (hijo.tarifa != null) {
            total += Number(hijo.tarifa.importeEntrada)
          }
        }
        total += Number(this.tarifa.importeEntrada)
        return total
      } else {
        let total = 0
        for (let hija of this.tarifaReservaHijas) {
          total += Number(hija.importeEntrada)
        }
        total += Number(this.tarifaReserva.importeEntrada)
        return total
      }
    },
    entradaPorcentaje () {
      return this.entrada / this.total * 100
    },
    // sumatorio numero de cuotas
    numeroCuotas () {
      if (this.incrustado) {
        let nCuotas = 0
        for (let hijo of this.inmueble.inmueblesHijos) {
          if (hijo.tarifa != null) {
            if (hijo.tarifa.aplazados != null) {
              for (let e = 0; e < hijo.tarifa.aplazados.length; e++) {
                nCuotas += Number(hijo.tarifa.aplazados[e].numeroEfectos)
              }
            }
          }
        }
        for (let i = 0; i < this.aplazadosStore.length; i++) {
          nCuotas += Number(this.aplazadosStore[i].numeroEfectos)
        }
        return nCuotas
      } else {
        let nCuotas = 0
        for (let hija of this.tarifaReservaHijas) {
          if (hija.aplazados != null) {
            for (let e = 0; e < hija.aplazados.length; e++) {
              nCuotas += Number(hija.aplazados[e].numeroEfectos)
            }
          }
        }
        for (let i = 0; i < this.tarifaReserva.aplazados.length; i++) {
          nCuotas += Number(this.tarifaReserva.aplazados[i].numeroEfectos)
        }
        return nCuotas
      }
    },
    // calculamos el importe o porcentaje de las cuotas en base al que tengamos
    cuotas () {
      if (this.incrustado) {
        let total = 0
        for (let hijo of this.inmueble.inmueblesHijos) {
          if (hijo.tarifa != null) {
            let auxPorcentajeHijo = 0
            if (hijo.tarifa.importeAplazado == null || Number(hijo.tarifa.importeAplazado === 0)) {
              if (hijo.tarifa.porcentajeAplazado != null && hijo.tarifa.porcentajeAplazado !== 0) {
                auxPorcentajeHijo = hijo.tarifa.porcentajeAplazado
              }
              total += Number(hijo.tarifa.importeTotal * auxPorcentajeHijo / 100)
            } else {
              total += Number(hijo.tarifa.importeAplazado)
            }
          }
        }
        let auxPorcentajeAplazado = 0
        if (this.tarifa.importeAplazado == null || Number(this.tarifa.importeAplazado) === 0) {
          if (this.tarifa.porcentajeAplazado != null && this.tarifa.porcentajeAplazado !== 0) {
            auxPorcentajeAplazado = this.tarifa.porcentajeAplazado
          }
          total += Number(this.tarifa.importeTotal * auxPorcentajeAplazado / 100)
        } else {
          total += Number(this.tarifa.importeAplazado)
        }
        return total
      } else {
        let total = 0
        let auxPorcentajeHija = 0
        for (let hija of this.tarifaReservaHijas) {
          if (hija.importeAplazado == null || Number(hija.importeAplazado) === 0) {
            if (hija.porcentajeAplazado != null && hija.porcentajeAplazado !== 0) {
              auxPorcentajeHija = hija.porcentajeAplazado
            }
            total += Number(hija.importeTotal * auxPorcentajeHija / 100)
          } else {
            total += Number(hija.importeAplazado)
          }
        }
        let auxPorcentajeAplazado = 0
        if (this.tarifaReserva.importeAplazado == null || Number(this.tarifaReserva.importeAplazado) === 0) {
          if (this.tarifaReserva.porcentajeAplazado != null && this.tarifaReserva.porcentajeAplazado !== 0) {
            auxPorcentajeAplazado = this.tarifaReserva.porcentajeAplazado
          }
          total += Number(this.tarifaReserva.importeTotal * auxPorcentajeAplazado / 100)
        } else {
          total += Number(this.tarifaReserva.importeAplazado)
        }
        return total
      }
    },
    cuotasPorcentaje () {
      return this.cuotas / this.total * 100
    },
    aplazados () {
      if (this.incrustado) {
        let auxAplazadosHijos = []
        for (let hijo of this.inmueble.inmueblesHijos) {
          if (hijo.tarifa != null) {
            if (hijo.tarifa.aplazados != null) {
              for (let i = 0; i < hijo.tarifa.aplazados.length; i++) {
                auxAplazadosHijos.push(hijo.tarifa.aplazados[i])
              }
            }
          }
        }
        return this.aplazadosStore.concat(auxAplazadosHijos)
      } else {
        let auxAplazadosHijos = []
        let tarifasHijas = this.tarifaReservaHijas
        for (let tarifa of tarifasHijas) {
          if (tarifa.aplazados != null) {
            for (let i = 0; i < tarifa.aplazados.length; i++) {
              auxAplazadosHijos.push(tarifa.aplazados[i])
            }
          }
        }
        return this.tarifaReserva.aplazados.concat(auxAplazadosHijos)
      }
    },
    periodo () {
      switch (this.tarifa.periodicidadAlquiler) {
        case 1:
          return this.$t('reservas.resumenAlquiler.mensual')
        case 2:
          return this.$t('reservas.resumenAlquiler.biMensual')
        case 3:
          return this.$t('reservas.resumenAlquiler.trimestral')
        case 6:
          return this.$t('reservas.resumenAlquiler.semestral')
        case 12:
          return this.$t('reservas.resumenAlquiler.anual')
        default:
          return this.$t('reservas.resumenAlquiler.cadaXMeses', {tarifa: this.tarifa.periodicidadAlquiler})
      }
    },
    // calculamos el importe o porcentaje de la hipoteca en base al que tengamos
    resto () {
      if (this.incrustado) {
        let total = 0
        for (let hijo of this.inmueble.inmueblesHijos) {
          if (hijo.tarifa != null) {
            let auxPorcentajeHijo = 0
            if (hijo.tarifa.importeHipoteca == null || Number(hijo.tarifa.importeHipoteca === 0)) {
              if (hijo.tarifa.porcentajeHipoteca != null && hijo.tarifa.porcentajeHipoteca !== 0) {
                auxPorcentajeHijo = hijo.tarifa.porcentajeHipoteca
              }
              total += Number(hijo.tarifa.importeTotal * auxPorcentajeHijo / 100)
            } else {
              total += Number(hijo.tarifa.importeHipoteca)
            }
          }
        }
        let auxPorcentajeHipoteca = 0
        if (this.tarifa.importeHipoteca == null || Number(this.tarifa.importeHipoteca) === 0) {
          if (this.tarifa.porcentajeHipoteca != null && this.tarifa.porcentajeHipoteca !== 0) {
            auxPorcentajeHipoteca = this.tarifa.porcentajeHipoteca
          }
          total += Number(this.tarifa.importeTotal * auxPorcentajeHipoteca / 100)
        } else {
          total += Number(this.tarifa.importeHipoteca)
        }
        return total
      } else {
        let total = 0
        let auxPorcentajeHija = 0
        for (let hija of this.tarifaReservaHijas) {
          if (hija.importeHipoteca == null || Number(hija.importeHipoteca) === 0) {
            if (hija.porcentajeHipoteca != null && hija.porcentajeHipoteca !== 0) {
              auxPorcentajeHija = hija.porcentajeHipoteca
            }
            total += Number(hija.importeTotal * auxPorcentajeHija / 100)
          } else {
            total += Number(hija.importeHipoteca)
          }
        }
        let auxPorcentajeHipoteca = 0
        if (this.tarifaReserva.importeHipoteca == null || Number(this.tarifaReserva.importeHipoteca) === 0) {
          if (this.tarifaReserva.porcentajeHipoteca != null && this.tarifaReserva.porcentajeHipoteca !== 0) {
            auxPorcentajeHipoteca = this.tarifaReserva.porcentajeHipoteca
          }
          total += Number(this.tarifaReserva.importeTotal * auxPorcentajeHipoteca / 100)
        } else {
          total += Number(this.tarifaReserva.importeHipoteca)
        }
        return total
      }
    },
    restoPorcentaje () {
      return this.resto / this.total * 100
    },
    
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      downloadCondiciones: 'simplificada/downloadPDFCondiciones'
    }),
    
    replaceAll (texto) {
      return texto.replaceAll('€', '<euro>').replaceAll('+', '<mas>')
    },
    async aceptar () {
      if (!this.simplificada) {
        this.$refs.form.validate()
        if (!this.valid) {
          this.addAlert({texto: this.$t('reservas.condiciones.aceptoCondicionesPago'), color: 'error'})
          return
        }
        this.$emit('terminado')
      } else {
        await this.downloadCondiciones(this.reservaActual.id)
      }
      
    },
    pintadoMasIVA () {
      return this.iva === 0 ? '' : ' (+IVA)'
    },
    textoAplazado (aplazado) {
      let enLlaves = aplazado.enLlaves === 1
      let fijo = aplazado.mesFijo != null && aplazado.mesFijo > 0 && aplazado.anoVencimiento != null && aplazado.anoVencimiento > 0
      let texto = ''
      if (enLlaves) {
        texto += this.$t('reservas.condiciones.cuotaLlaves', {
          importe: this.$options.filters['currency'](aplazado.importe),
          masIva: this.pintadoMasIVA()
        })
      } else if (fijo) {
        texto += this.$t('reservas.condiciones.cuotaAplazado', {
          importe: this.$options.filters['currency'](aplazado.importe),
          masIva: this.pintadoMasIVA(),
          aplazado: aplazado.mesFijo,
          vencimiento: aplazado.anoVencimiento
        })
      } else {
        texto += this.$tc('reservas.condiciones.cuota', aplazado.numeroEfectos, {count: aplazado.numeroEfectos})
        if (aplazado.periodo > 0) {
          texto += ' ' + this.$tc('reservas.condiciones.mes', aplazado.periodo, {count: aplazado.periodo})
        }
        texto += ' ' + this.$t('reservas.condiciones.cuotaImporte', {
          importe: this.$options.filters['currency'](aplazado.importe),
          masIva: this.pintadoMasIVA(),
          vencimiento: this.$tc('reservas.condiciones.vencimiento', aplazado.mesVencimiento, {count: aplazado.mesVencimiento})
        })
      }
      return texto
    },
    importeTotalHijo (inmuebleHijo) {
      if (this.incrustado && inmuebleHijo.tarifa != null) {
        return inmuebleHijo.tarifa.importeTotal
      } else if (this.tarifaHijaByCodigoActivo(inmuebleHijo.codigoActivo)) {
        return this.tarifaHijaByCodigoActivo(inmuebleHijo.codigoActivo).importeTotal
      } else {
        return null
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/reservas/condiciones/Condiciones.vue